<template>
  <b-container class="container-rda" v-if="selected">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
        <h2 class="purple mb-5">
          Relatório de desenvolvimento do aluno (Antigo)
        </h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="profile-row">
          <b-col>
            <img
              v-if="selected.student.User.photo == null || ''"
              src="@/assets/images/default-photo.png"
              height="64"
              width="64"
              alt
            />
            <img
              v-else
              width="64"
              height="64"
              :src="`${selected.student.User.photo}`"
              alt
            />
            <div class="content-profile">
              <h5>{{ selected.student.User.name }}</h5>
              <p>Ciclo: {{ cycle.name }}</p>
            </div>
          </b-col>
        </div>
      </b-col>

      <b-col md="12" class="mt-5">
        <b-form-group class="accordion-materias">
          <b-row class="rda-tabs" style="margin-bottom: 20px">
            <b-col cols="4">
              <label for="label">Versão do Currículo</label>
              <SelectSimple
                v-if="versionOptions.length"
                v-model="selectedVersion"
                :options="versionOptions"
                :callback="getCyclesAndSubjects"
                :zIndex="1000"
              />
            </b-col>
            <b-col cols="3" v-if="cycleOptions.length">
              <label for="label">Ciclo</label>
              <SelectSimple
                v-model="selectedCycle"
                :options="cycleOptions"
                :callback="onCycleChange"
                :zIndex="999"
              />
            </b-col>
          </b-row>

          <label for="Turmas" class="grey1" v-if="selectedCycle">
            <strong>Disciplinas:</strong>
          </label>
          <div class="accordion" role="tablist" v-if="selectedCycle && subjects.length">
            <b-card no-body>
              <b-card-header header-tag="header" role="tab">
                <p block v-b-toggle="'accordion-subjects'">
                  {{ selectedCycle.label }}
                </p>
              </b-card-header>

              <b-collapse
                id="accordion-subjects"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-form-checkbox-group
                    id="checkbox-group-subjects"
                    v-model="subjectsSelected"
                    name="flavour-2"
                  >
                    <b-form-checkbox
                      v-for="subject in subjects"
                      :key="subject.id"
                      :value="subject"
                      >{{ subject.designation }}</b-form-checkbox
                    >
                  </b-form-checkbox-group>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </b-form-group>
      </b-col>

      <b-col md="12" v-if="selectedCycle" class="mt-4">
        <b-form-group label-class="grey1">
          <label for="Incluir conteúdos marcados:" class="mt-4 mb-4 grey1">
            <strong>Incluir conteúdos marcados:</strong>
          </label>

          <b-form-checkbox
            style="padding-left: 5px;"
            v-model="isParentVersion"
            name="parent-version"
            class="mb-3"
            @change="handleParentVersionChange"
          >
            Versão para os responsáveis
          </b-form-checkbox>
        </b-form-group>

        <b-form-group class="group-radio" v-slot="{ ariaDescribedby }">
          <div class="container-fluid">
            <div class="row">
              <b-form-radio
                v-model="selectedStatus"
                :aria-describedby="ariaDescribedby"
                name="matricula"
                value="All"
                class="col-md-12 mb-4"
                md="12"
              >
                {{ !isParentVersion ? 'Todos os valores' : 'Todos os valores exceto #' }}
              </b-form-radio>

              <b-form-radio
                v-model="selectedStatus"
                :aria-describedby="ariaDescribedby"
                name="matricula"
                value="A"
                class="col-md-2 mb-4"
              >
                Apenas com
                <strong>A</strong>
              </b-form-radio>

              <b-form-radio
                v-model="selectedStatus"
                :aria-describedby="ariaDescribedby"
                name="matricula"
                value="EE"
                class="col-md-2 mb-4"
              >
                Apenas com
                <strong>EE</strong>
              </b-form-radio>

              <b-form-radio
                v-model="selectedStatus"
                :aria-describedby="ariaDescribedby"
                name="matricula"
                value="AN"
                class="col-md-2 mb-4"
              >
                Apenas com
                <strong>AN</strong>
              </b-form-radio>

              <div class="w-100"></div>

              <b-form-radio
                v-model="selectedStatus"
                :aria-describedby="ariaDescribedby"
                name="matricula"
                value="*"
                class="col-md-2 mb-4"
              >
                Apenas com
                <strong>*</strong>
              </b-form-radio>

              <b-form-radio
                v-if="!isParentVersion"
                v-model="selectedStatus"
                :aria-describedby="ariaDescribedby"
                name="matricula"
                value="#"
                class="col-md-2 mb-4"
              >
                Apenas com
                <strong>#</strong>
              </b-form-radio>

              <b-form-radio
                v-model="selectedStatus"
                :aria-describedby="ariaDescribedby"
                name="matricula"
                value="blank"
                :class="isParentVersion ? 'col-md-4 mb-4' : 'col-md-2 mb-4'"
              >
                Conteúdos
                <strong>em branco</strong>
              </b-form-radio>
            </div>
          </div>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row align-h="end">
      <b-col md="3" class="mt-5">
        <b-button
          :to="{
            name: 'alunos',
          }"
          class="large blue outline"
          >Voltar</b-button
        >
      </b-col>

      <b-col md="3" class="mt-5">
        <b-button
          @click="exportReport"
          class="large blue"
          :class="{ disabled: subjectsSelected.length === 0 }"
          >{{ loadText }}</b-button
        >
      </b-col>
    </b-row>
  </b-container>
  <b-container class="mt-5 container-rda" v-else-if="this.$route.params.id">
    <p>Carregando</p>
  </b-container>
  <b-container class="mt-5 container-rda" v-else>
    <p>Nenhum aluno selecionado</p>
  </b-container>
</template>

<script>
import DataService from "@/services/students.service";
import httpRda from "../../http-rda";
import SelectSimple from "@/components/inputs/SelectSimple.vue";

export default {
  name: "StudentDevelopmentReportOld",
  components: {
    SelectSimple,
  },
  data() {
    return {
      breadcrumb: [
        {
          text: "Registros Antigos",
          href: "/alunos-registros-antigos",
        },
        {
          text: "Relatório de desenvolvimento do aluno (Antigo)",
          active: true,
        },
      ],
      versionOptions: [],
      cycleOptions: [],
      selectedVersion: null,
      selectedCycle: null,
      cyclesData: [],
      selected: null,
      student: {
        User: {},
      },
      cycle: "",
      classroom: "",
      subjects: [],
      loadText: "Exportar",

      subjectsSelected: [],
      selectedStatus: "All",
      isParentVersion: false,
    };
  },
  methods: {
    handleParentVersionChange() {
      if (this.isParentVersion) {
        if (this.selectedStatus === "#") {
          this.selectedStatus = "All";
        }
      }
    },

    async getStudentVersions() {
      const id = this.$route.params.id;
      if (id) {
        await httpRda
          .get(`/tutoring-old/student/${id}/versions`)
          .then(async (res) => {
            this.versionOptions = res.data.result.map((version) => ({
              id: version.id,
              label: version.label,
            }));
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    async getCyclesAndSubjects(version) {
      this.selectedVersion = version;
      this.cycleOptions = [];
      const id = this.$route.params.id;
      if (!id || !version) return;

      try {
        const res = await httpRda.get(
          `/tutoring-old/student/${id}/versions/${version.id}/cycles`
        );

        this.cyclesData = res.data.result;
        this.cycleOptions = this.cyclesData.map((cycle) => ({
          id: cycle.id,
          label: cycle.designation,
        }));

        // Limpar seleções anteriores
        this.selectedCycle = null;
        this.subjects = [];
        this.subjectsSelected = [];
      } catch (error) {
        console.error("Erro ao buscar ciclos:", error);
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Não foi possível carregar os ciclos!",
          footer: "Por favor, tente novamente mais tarde.",
        });
      }
    },

    onCycleChange(cycle) {
      if (!cycle) {
        this.subjects = [];
        this.subjectsSelected = [];
        return;
      }
      this.selectedCycle = cycle;

      const cycleData = this.cyclesData.find((c) => c.id === cycle.id);
      if (cycleData) {
        this.subjects = cycleData.subjects;
        this.subjectsSelected = [];
      }
    },

    getSelected(id) {
      DataService.getStudent(id)
        .then((response) => {
          this.selected = response.data;
        })
        .catch((error) => {
          return error;
        });

      DataService.getStudentClassroomCycle(id)
        .then((response) => {
          this.cycle = response.data.classroom.Cycle;
        })
        .catch((error) => {
          return error;
        });

      DataService.getStudentClassroom(id)
        .then((response) => {
          this.classroom = response.data.classroom;
        })
        .catch((error) => {
          return error;
        });
    },

    exportReport() {
      if (!this.selectedVersion) {
        this.$swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Por favor, selecione uma versão do currículo.",
        });
        return;
      }

      let data = {
        cycleId: this.selectedCycle.id,
        subject_ids: this.subjectsSelected.map((s) => s.id),
        status: this.selectedStatus,
        version: this.selectedVersion.id,
        isParentVersion: this.isParentVersion,
      };

      this.loadText = "Por favor, aguarde...";

      DataService.exportStudentReport(this.$route.params.id, data)
        .then((response) => {
          this.subjectsSelected = [];
          this.loadText = "Exportar";

          let date = new Date();

          let newBlob = new Blob([response.data], { type: "application/pdf" });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
          }

          data = window.URL.createObjectURL(newBlob);
          let link = document.createElement("a");
          link.href = data;
          link.download = `Relat_Antigo_Desenv_${
            this.selected.student.User.name
          }_${date.getDate()}-${date.getMonth()}-${date.getFullYear()}_${date.getTime()}`;
          link.click();

          setTimeout(function () {
            window.URL.revokeObjectURL(data);
          }, 100);

          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: `Relatório exportado com sucesso!`,
          });

          return response;
        })
        .catch((error) => {
          this.loadText = "Exportar";
          this.subjectsSelected = [];

          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel exportar o relatório!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error;
        });
    },
  },

  created() {
    this.getStudentVersions();
    this.getSelected(this.$route.params.id);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
</style>
